///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.abc_item = abcsetup.abc_item || {};
abcsetup.abc_item.index = abcsetup.abc_item.index || {};
abcsetup.abc_item.index.item_id = '';


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.abc_item.index.item_id = null;


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.abc_item.index = {
    init() {
        abcsetup.setTitle('Existing Items');

        // Maintenance History button clicked
        $(document).on('click', ".maintenance_history", function () {
            $(this).css("cursor", "progress");
            abcsetup.abc_item.index.item_id = $(this).data("entity-id");

            axios.get('/api/abc_item/maintenance_history/' + abcsetup.abc_item.index.item_id).then(response => {
                $(this).css("cursor", "pointer");
                $(response.data).modal('show');
            });
        });

        // Image Attachments button clicked
        $(document).on('click', '.image_attachments', function () {
            $(this).css('cursor', 'progress');
            abcsetup.abc_item.index.item_id = $(this).data("entity-id");

            axios.get('/api/abc_item/image_attachments/' + abcsetup.abc_item.index.item_id).then(response => {
                $(this).css("cursor", "pointer");
                $(response.data).modal('show');
            });
        });

        // Copy item button clicked
        $(document).on('click', ".copy_item", function () {
            $(this).css("cursor", "progress");
            abcsetup.abc_item.index.item_id = $(this).data("entity-id");

            axios.get('/api/abc_item/copy_item/' + abcsetup.abc_item.index.item_id).then(response => {
                $(this).css("cursor", "pointer");
                $(response.data).modal('show');
            });
        });

        // Copy item confirm button clicked
        $(document).on('click', "#copy-item-modal .btn-copy", function () {
            var copy_attachments = false;
            if ($('#copy_attachments').prop("checked") == true) {
                copy_attachments = true;
            }
            $(this).css("cursor", "progress").attr('disabled', true);
            axios.post('/api/abc_item/copy_item/' + abcsetup.abc_item.index.item_id, {copy_attachments: copy_attachments}).then(response => {
                $(this).css("cursor", "pointer");
                if (response.data.error) {
                    $('.modal-footer').html('<div class="alert alert-warning">' + response.data.error + '</div>');
                } else {
                    window.location.href = response.data.goto_route;
                }
            });
        });

        // Maintain item button clicked
        $(document).on('click', ".maintenance", function () {
            $(this).css("cursor", "progress");
            abcsetup.abc_item.index.item_id = $(this).data("entity-id");

            axios.get('/api/abc_item/maintenance/' + abcsetup.abc_item.index.item_id).then(response => {
                $(this).css("cursor", "pointer");
                $(response.data).modal('show');
            });
        });

        // Maintain item confirm button clicked
        $(document).on('click', "#maintain-item-modal .btn-maintain", function () {
            $(this).css("cursor", "progress").attr('disabled', true);
            axios.post('/api/abc_item/maintenance/' + abcsetup.abc_item.index.item_id).then(response => {
                $(this).css("cursor", "pointer");
                if (response.data.error) {
                    $('.modal-footer').html('<div class="alert alert-warning">' + response.data.error + '</div>');
                } else {
                    window.location.href = response.data.goto_route;
                }
            });
        });
    },
}
